import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import ModuleVersionInputsCodePreview from "../../components/CodePreview";
import { ModuleVersionRequiredInputRow } from "../types";

const ModuleVersionInputsTableTypeCell = <T extends ModuleVersionRequiredInputRow>({
  item: input,
  ...cellProps
}: TableSimpleCellProps<T>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <ModuleVersionInputsCodePreview code={input.type} title={`${input.id} type`} />
    </TableSimpleCell>
  );
};

export default ModuleVersionInputsTableTypeCell;
